import classNames from 'classnames';
import { forwardRef } from 'react';
import ConstructorVideoCard from '@/shared/components/shared/ConstructorVideoCard';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { ImageShape, VideoShape } from '@/shared/lib/types';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        text?: string | null;
        image?: ImageShape | null;
        video?: VideoShape | null;
    };
};

const ConstructorVideo = forwardRef<HTMLDivElement, Props>(({ properties: { text, image, video }, ...props }, ref) => {
    const tpTitle = useTypograf(text ?? '');

    return (
        <div ref={ref} {...props} className={classNames('constructor-block constructor-video', props.className)}>
            {video && <ConstructorVideoCard ref={ref} video={video} image={image} />}
            {tpTitle && <p className="constructor-video-text text-xs">{tpTitle}</p>}
        </div>
    );
});

ConstructorVideo.displayName = 'ConstructorVideo';

export default ConstructorVideo;
